import { useI18n } from '@/locales';
import { computed, unref } from 'vue';

export function useTemplateError(template) {
  const { t } = useI18n();
  const firstError = computed(() => unref(template).inspectErrors?.[0] ?? undefined);

  function getErrorLong(error) {
    if (!error) return undefined;

    const errorsMap = {
      undefined: t('templateModule.status.failed.reason.undefined'),
      unopened_tag: t('templateModule.status.failed.reason.unopenedTag', {
        tag: error.tag,
      }),
      unclosed_tag: t('templateModule.status.failed.reason.unclosedTag', {
        tag: error.tag,
      }),
      incorrect_image_tag_case: t('templateModule.status.failed.reason.incorrectImageTag', {
        tag: error.tag,
      }),
    };

    return errorsMap[error.code] ?? errorsMap.undefined;
  }

  return {
    errorDescription: computed(() => getErrorLong(firstError.value)),
  };
}
